import(/* webpackMode: "eager", webpackExports: ["ProjectConfigurator"] */ "/vercel/path0/components/contact/ProjectConfigurator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/vercel/path0/components/illustrations/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionPage"] */ "/vercel/path0/components/motion/MotionPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/vercel/path0/components/sections/PageHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
